import React, { useState, useEffect } from "react";
import "./ImageCarousel.css"; // Import CSS for styling

const images = [
  "/content/images/1.jpg",
  "/content/images/4.jpg",
  "/content/images/5.jpg",
];

function ImageCarousel() {
  const [currentIndex, setCurrentIndex] = useState(0);

  // Automatically change the image after a certain interval
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === images.length - 1 ? 0 : prevIndex + 1
      );
    }, 6000); // Change image every 6 seconds

    return () => clearInterval(interval); // Cleanup the interval on component unmount
  }, []);

  const goToImage = (index) => {
    setCurrentIndex(index);
  };

  return (
    <div className="carousel">
      {/* Display the current image */}
      <img
        src={images[currentIndex]}
        alt={`Slide ${currentIndex}`}
        className="carousel__image"
      />

      {/* Image navigation dots */}
      <div className="carousel__dots">
        {images.map((_, index) => (
          <button
            key={index}
            onClick={() => goToImage(index)}
            className={`carousel__dot ${
              currentIndex === index ? "carousel__dot--active" : ""
            }`}
          ></button>
        ))}
      </div>
    </div>
  );
}

export default ImageCarousel;
